module.exports = __webpack_public_path__ + "img/home_hero_mobile.ba379b8f.jpg";